import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeartPulse, faStar, faQuoteRight, faHeart } from "@fortawesome/free-solid-svg-icons";
import NavbarLogo from "../../components/Navbar/csdv2Logo.png";
import RohanImage from "../../assets/ourstories/rohan.jpeg";
import SnehaImage from "../../assets/ourstories/sneha.jpeg";
import IshaanImage from "../../assets/ourstories/ishaan.jpeg";

const STORIES = [
  {
    title: "A Father’s Hope, A Child’s Life",
    image: RohanImage,
    story: "Rohan was born with a large hole in his heart. His father, a daily wage laborer, couldn't afford the complex surgery. Shishu Hriday intervened within 48 hours, funding the entire surgery. Today, Rohan is a healthy boy attending school.",
  },
  {
    title: "Through the Eyes of Resilience",
    image: SnehaImage,
    story: "Sneha's condition was critical when she reached us. After a successful landmark surgery facilitated by Dr. Ashok Raju Alluri's team, she's now aspiring to be a doctor herself to save other little hearts.",
  },
  {
    title: "A Community of Caring",
    image: IshaanImage,
    story: "Ishaan's journey shows the power of early screening. Identified during one of our rural camps, he was treated immediately, avoiding lifelong complications.",
  }
];

const OurStories = () => {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      {/* Hero Section */}
      <section className="relative py-32 gradient-bg text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10 bg-white" />
        <div className="container mx-auto px-6 text-center relative z-10">
          <h1 className="text-5xl md:text-8xl font-black mb-6 tracking-tighter flex flex-col md:flex-row items-center justify-center gap-6">
            <img src={NavbarLogo} alt="Logo" className="hidden md:block md:h-32 w-auto" />
            <span>Stories of <span className="italic opacity-80">Hope</span></span>
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto font-light opacity-90 leading-relaxed">
            Every surgery we fund is more than just a medical procedure -  it's a second chance at childhood.
          </p>
        </div>
      </section>

      {/* Featured Stories */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6">
          <div className="space-y-32">
            {STORIES.map((story, i) => (
              <div key={i} className={`flex flex-col ${i % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-20 items-center`}>
                <div className="lg:w-1/2 relative">
                  <div className="absolute -top-10 -left-10 w-40 h-40 bg-brand-red/10 rounded-full blur-[80px]" />
                  <img
                    src={story.image}
                    alt={story.title}
                    className="rounded-[3rem] shadow-2xl relative z-10 w-full object-cover aspect-[4/3] border-8 border-white hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute top-10 right-10 z-20 bg-white px-6 py-3 rounded-2xl shadow-2xl flex items-center gap-3">
                    <FontAwesomeIcon icon={faStar} className="text-brand-gold" />
                    <span className="font-black text-slate-900 uppercase tracking-widest text-xs">Success Story</span>
                  </div>
                </div>
                <div className="lg:w-1/2">
                  <h2 className="text-4xl font-black text-slate-900 mb-8 tracking-tighter uppercase">{story.title}</h2>
                  <div className="relative">
                    <FontAwesomeIcon icon={faQuoteRight} className="absolute -top-10 -left-10 text-slate-100 text-[10rem] opacity-50" />
                    <p className="text-slate-600 text-xl leading-relaxed relative z-10 italic font-medium">
                      "{story.story}"
                    </p>
                  </div>
                  <div className="mt-12 flex items-center gap-6 p-8 glass rounded-[2.5rem] border-slate-100 border">
                    <div className="w-16 h-16 gradient-bg text-white rounded-2xl flex items-center justify-center text-2xl shadow-xl">
                      <FontAwesomeIcon icon={faHeartPulse} className="animate-pulse" />
                    </div>
                    <div>
                      <h4 className="font-black text-slate-900 text-lg uppercase tracking-tight">100% Recovered</h4>
                      <p className="text-slate-500 font-bold text-sm">Surgery fully funded by Shishu Hriday</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Impact Section */}
      <section className="py-32 bg-slate-900 text-white text-center">
        <div className="container mx-auto px-6">
          <h2 className="text-3xl md:text-5xl font-black tracking-tighter mb-12 max-w-2xl mx-auto leading-tight italic opacity-90">
            "Behind every success story is a donor who said <span className="text-brand-red">'Yes'</span>."
          </h2>
          <Link to="/donate-now" className="inline-block px-12 py-5 gradient-bg text-white rounded-full font-black text-xl hover-glow transform hover:scale-105 transition-all shadow-2xl uppercase tracking-tighter">
            Support a child <FontAwesomeIcon icon={faHeart} className="ml-2" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default OurStories;